<template>
  <v-text-field
    :value="value"
    @input="value => emit(value)"
    type="number"
    :label="config.label"
    :name="config.key"
    :required="config.required"
    :id="config.key"
    :error="haveErrors()"
    :rules="config.errors"
    :min="0"
    :step="1"
    :suffix="$t('inputs.minute.minutes')">
  </v-text-field>
</template>

<script>
  import input from '@/mixins/input'
  export default {
    mixins: [input]
  }
</script>



// WEBPACK FOOTER //
// src/components/inputs/Minute.vue